import { IconNames } from '@blueprintjs/icons';
import { Button } from '@strata/react-buttons';
import { Dialog } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';

import { handleError } from 'services/Error';
import { useDeleteFillActivityMutation } from 'store/api/userSupportApi';

const Title = 'Delete Fill Activity';

interface DeleteFillActivityDialogProps {
    isOpen: boolean;
    eventId?: string;
    referralId?: string;
    eventStatus?: string;
    onClose: () => void;
}

export const DeleteFillActivityDialog = ({
    isOpen,
    eventId = undefined,
    referralId = undefined,
    eventStatus = undefined,
    onClose,
}: DeleteFillActivityDialogProps) => {
    const [deleteFillActivity] = useDeleteFillActivityMutation();

    return (
        <Dialog
            isOpen={isOpen}
            dialogTitle={Title}
            headerIcon={IconNames.WARNING_SIGN}
            onSecondaryButtonClick={() => {
                onClose();
            }}
            onPrimaryButtonClick={() => {
                void (async () => {
                    try {
                        await deleteFillActivity({
                            eventId: eventId!,
                            referralId: referralId!,
                        }).unwrap();
                        SuccessToast({
                            message: 'Fill activity deleted successfully.',
                        });
                        onClose();
                    } catch (error) {
                        handleError(
                            'An error occurred deleting fill activity. Please try again.',
                            error as Error,
                        );
                    }
                })();
            }}
            primaryButtonLabel="Yes, Delete Fill Activity"
            primaryButtonIntent={Button.Intent.DANGER}
            secondaryButtonLabel="Cancel"
            dialogContent={
                <>
                    <div className="padding__bottom--medium">
                        Are you sure you want to delete this Fill Activity?
                    </div>
                    <div className="sds_fill-activity__status-to-delete">{eventStatus}</div>
                </>
            }
        />
    );
};

DeleteFillActivityDialog.Title = Title;
